/* @Author: 李文 
 * @Last Modified by:   李文  */
import React from 'react';
import { Radio } from 'antd';
import ReactEcharts from "echarts-for-react";
import echarts from "echarts/lib/echarts";
import * as Actions from '../../../actions/bussinessStatistics';
import './resourceStatistics.scss' 


class ResourceStatistics extends React.Component{
    constructor(props){
        super(props);
        this.state={
            activeKey: 'month',
            total:[],
            xAxisData:[],
            yAxisData:{},
        
        }
    }

    componentDidMount(){
       this.getData()
    }

    
 
    getData =  () => {
        let params = { type: this.state.activeKey};
        let totalData = {};
        let xAxisData = [];
        let yAxisData = {};
        Actions.getStatistics({...params,resourceType: 1},(res) => {
            if(res){
                totalData.story = res.total;
                delete res.total;
                let data = [];
                for(var key in res){
                    let mark=this.state.activeKey==='month'?'月':'年';
                    xAxisData.push(key+mark);
                    data.push(res[key]);
                }
                yAxisData.story = data
                this.setState({
                    total: totalData,
                    xAxisData,
                    yAxisData
                })
            } 
        })
        Actions.getStatistics({...params,resourceType: 2},(res) => {
            if(res){
                totalData.picture = res.total;
                delete res.total;
                let data = [];
                for(var key in res){
                    data.push(res[key]);
                }
                yAxisData.picture = data
                this.setState({
                    total: totalData,
                    yAxisData
                })
            } 
        })
        Actions.getStatistics({...params,resourceType: 3},(res) => {
            if(res){
                totalData.video = res.total;
                delete res.total;
                let data = [];
                for(var key in res){
                    data.push(res[key]);
                }
                yAxisData.video = data
                this.setState({
                    total: totalData,
                    yAxisData
                })
            } 
        })
        Actions.getStatistics({...params,resourceType: 5},(res) => {
            if(res){
                totalData.audio = res.total;
                delete res.total;
                let data = [];
                for(var key in res){
                    data.push(res[key]);
                }
                yAxisData.audio = data
                this.setState({
                    total: totalData,
                    yAxisData
                })
            } 
        })
        
    }

    getOptions = () => {
        const options = {
            // title: {
            //     text: '某地区蒸发量和降水量',
            //     subtext: '纯属虚构'
            // },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['稿件','图片','视频','音频'],   
            },
            toolbox: {
                show: false, //工具栏
            },
            color: ['#57a9ee', '#70c781', '#fb9898','#CE9ABF'],
            xAxis: [
                {
                    name: '时间',
                    data: this.state.xAxisData,
                }
            ],
            yAxis: [
                {
                    name: '单位：篇（个）',
                    type: 'value',
                    axisTick: { show: false },
                    splitLine: {
                        show: false,   // 网格线是否显示
                    },
                },
            ],
            series: [
                {
                    name: '稿件',
                    type: 'bar',
                    data: this.state.yAxisData.story ? this.state.yAxisData.story : [],
                },
                {
                    name: '图片',
                    type: 'bar',
                    data: this.state.yAxisData.picture ? this.state.yAxisData.picture : [],
                },
                {
                    name: '视频',
                    type: 'bar',
                    data: this.state.yAxisData.video ? this.state.yAxisData.video : [],
                },
                {
                    name: '音频',
                    type: 'bar',
                    data: this.state.yAxisData.audio ? this.state.yAxisData.audio : [],
                },
            ]
        }

        return options

    }

    changeTab = (e) => {
        this.setState({
            activeKey: e.target.value,
            total:[],
            xAxisData:[],
            yAxisData:{},
        }, () => {
            this.getData()
        })
    }


    render(){
        const { activeKey,total } = this.state;
        return(
            <div className="resource-statistics">
                <div className="resource-statistics-left">
                    <div>
                        <span>稿件数</span>
                        <span>{total.story ? total.story : 0}</span>
                    </div>
                   <div>
                       <span>图片数</span>
                       <span>{total.picture ? total.picture : 0}</span>
                   </div>
                   <div>
                       <span>视频数</span>
                       <span>{total.video ? total.video : 0}</span>
                   </div>
                   <div>
                       <span>音频数</span>
                       <span>{total.audio ? total.audio : 0}</span>
                   </div>

                </div>
                <div className="resource-statistics-right">
                    <div className="resource-statistics-right-options">
                    <Radio.Group value={activeKey} onChange={this.changeTab}>
                        <Radio.Button value="month">本年</Radio.Button>
                        <Radio.Button value="year">历年</Radio.Button>
                    </Radio.Group>
                    </div>
                <ReactEcharts
                            option={this.getOptions()}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%', height: '100%'}}
                        />
                </div>
            
            </div>
        )
    }
}

export default ResourceStatistics